/**
 * PreviewModeBanner — sticky top banner shown while admin is impersonating a user.
 * Click "Exit Preview" to restore admin role and return to /admin.
 */
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Eye, X } from "lucide-react";

export default function PreviewModeBanner() {
    const { previewMode, exitPreview } = useAuth();
    const navigate = useNavigate();

    if (!previewMode) return null;

    const exit = () => {
        exitPreview();
        navigate("/admin");
    };

    return (
        <div
            data-testid="preview-mode-banner"
            className="sticky top-0 z-[60] w-full bg-amber-500 text-slate-950 border-b border-amber-700 shadow-lg"
            role="status"
            aria-live="polite"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-2 text-xs sm:text-sm font-bold">
                    <Eye className="w-4 h-4 flex-shrink-0" />
                    <span className="tracking-wide">You are in User Preview Mode — Admin</span>
                </div>
                <button
                    onClick={exit}
                    data-testid="exit-preview-btn"
                    className="inline-flex items-center gap-1.5 px-3 h-8 rounded bg-slate-950 text-amber-400 hover:bg-slate-900 text-[11px] font-bold uppercase tracking-widest"
                >
                    <X className="w-3.5 h-3.5" /> Exit Preview
                </button>
            </div>
        </div>
    );
}
